module.exports = __webpack_public_path__ + "img/share.04830824.svg";